<template>
  <div class="main">
    <c-panel title="Manutenção" titleIcon="fas fa-tools">
      <form-manutencao :paramId="id" @onSubmitManutencao="afterSubmit"></form-manutencao>
    </c-panel>
  </div>
</template>

<script>
import formManutencao from "./form"

export default {
  components: { formManutencao },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/manutencao') }
  }
}
</script>

